// extracted by mini-css-extract-plugin
export default {"modalContainer":"DIDSMSViewModal_modalContainer__iJsol","modalTitle":"DIDSMSViewModal_modalTitle__0RJOb","text":"DIDSMSViewModal_text__mcnA4"};